export const resources = {
  IndexingSingleFileLabel: '',
  IndexingMultiFilesLabel: '',
  IndexingReviewPageTitle: ''
};
